import i18n from '@/i18n'

export default [
  {
    path: '/transactions',
    component: () => import(/* webpackChunkName: "Transactions" */ '@/views/Transactions.vue'),
    meta: {
      noContextRequired: true
    },
    children: [
      {
        path: '',
        name: 'transactionsOverview',
        component: () => import(/* webpackChunkName: "Transactions" */ '@/components/Transactions/Overview/TransactionsOverview.vue'),
        meta: {
          permissions: ['Mapi.Transactions.Read'],
          // shortcut: 'g t',
          menu: {
            index: 30,
            routeName: 'transactionsOverview',
            activeWhen: ['transactionsOverview', 'paymentJobDetail', 'paymentJobTrace', 'transactionsOverview', 'transactionDetail'],
            title: i18n.t('label.transactions'),
            icon: ['fal', 'money-check-alt']
          }
        }
      },
      {
        path: ':transactionReference',
        name: 'transactionDetail',
        component: () => import(/* webpackChunkName: "Transactions" */ '@/components/Transactions/Detail/TransactionDetail.vue'),
        meta: {
          permissions: ['Mapi.Transaction.Read']
        },
        props: true
      }
    ]
  }
]
